import { useMemo } from 'react';
import type { SflSemantic } from './tokens';

/** CSS variable references — theme switches via `.dark` on document root */
export type SflColors = {
  bg: string;
  surface: string;
  surface2: string;
  surface3: string;
  text: string;
  text2: string;
  text3: string;
  border: string;
  border2: string;
  accent: string;
  accentLight: string;
  teal: string;
  tealLight: string;
  amber: string;
  amberLight: string;
  coral: string;
  coralLight: string;
  blue: string;
  blueLight: string;
  pink: string;
  pinkLight: string;
  green: string;
  greenLight: string;
};

const CSS: SflColors = {
  bg: 'var(--sfl-bg)',
  surface: 'var(--sfl-surface)',
  surface2: 'var(--sfl-surface2)',
  surface3: 'var(--sfl-surface3)',
  text: 'var(--sfl-text)',
  text2: 'var(--sfl-text2)',
  text3: 'var(--sfl-text3)',
  border: 'var(--sfl-border)',
  border2: 'var(--sfl-border2)',
  accent: 'var(--sfl-accent)',
  accentLight: 'var(--sfl-accent-light)',
  teal: 'var(--sfl-teal)',
  tealLight: 'var(--sfl-teal-light)',
  amber: 'var(--sfl-amber)',
  amberLight: 'var(--sfl-amber-light)',
  coral: 'var(--sfl-coral)',
  coralLight: 'var(--sfl-coral-light)',
  blue: 'var(--sfl-blue)',
  blueLight: 'var(--sfl-blue-light)',
  pink: 'var(--sfl-pink)',
  pinkLight: 'var(--sfl-pink-light)',
  green: 'var(--sfl-green)',
  greenLight: 'var(--sfl-green-light)',
};

export type SflSemanticPair = { background: string; foreground: string };

export type SflColorsWithSemantics = SflColors & { semanticPairs: Record<SflSemantic, SflSemanticPair> };

export function getSflColors(): SflColorsWithSemantics {
  const semanticPairs: Record<SflSemantic, SflSemanticPair> = {
    accent: { background: CSS.accentLight, foreground: CSS.accent },
    blue: { background: CSS.blueLight, foreground: CSS.blue },
    teal: { background: CSS.tealLight, foreground: CSS.teal },
    amber: { background: CSS.amberLight, foreground: CSS.amber },
    coral: { background: CSS.coralLight, foreground: CSS.coral },
    pink: { background: CSS.pinkLight, foreground: CSS.pink },
    green: { background: CSS.greenLight, foreground: CSS.green },
  };
  return { ...CSS, semanticPairs };
}

export function useSflColors(): SflColorsWithSemantics {
  return useMemo(() => getSflColors(), []);
}
